import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { price_detail } from '@/services/http';
import { readCookie } from '@/tools/tools';
/**
 * getters
 */
// export const getters: GetterTree<CardState, RootState> = {
//   addresslist: (state: CardState) => state.cardnumber,
// };
/**
 * mutations
 */
export var mutations = {
  // 购物车变化
  CARDNUMBER: function CARDNUMBER(state, payload) {
    state.whiteStauts = payload;
  }
};
/**
 * actions
 */
export var actions = {
  setWhiteStauts: function setWhiteStauts(_ref) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, anchor, reslist;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            //获取白拿状态
            anchor = readCookie('anchor');
            _context.next = 4;
            return price_detail({
              companyId: 1,
              // cartIds: selectedIds,
              src: anchor ? anchor.src ? anchor.src : 2 : 4,
              equip: anchor ? anchor.equip : 4,
              version: anchor ? anchor.version : '',
              model: anchor ? anchor.model : '',
              equipVersion: anchor ? anchor.equipVersion : '',
              equipMeid: anchor ? anchor.equipMeid : '',
              languageType: anchor ? Number(anchor.languageType) + 1 : ''
            });
          case 4:
            reslist = _context.sent;
            commit('CARDNUMBER', reslist.data.data);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};
/**
 * state
 */
export var state = {
  whiteStauts: {}
};
var namespaced = true;
export var white = {
  namespaced: namespaced,
  state: state,
  // getters,
  mutations: mutations,
  actions: actions
};